import gql from 'graphql-tag';

export const GET_ALL_RESERVED_TASK_NAMES_QUERY = gql`
  query GetAllReservedTaskNamesQuery {
    taskNames: getAllReservedTaskNames
  }
`;
